@if (articleResult$ | async; as articleResult) {
    <h4><strong>{{articleResult.articles[0].body.structure.keip_name}}</strong></h4>
    @if (articleResult.articles[0]; as document) {
        <keip-view [keip]="document.body.structure"></keip-view>
    }
}
